/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 78845d9823ce36a32892311299ebe1fa074d4c9117385c11d20ef109d99c9931
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Nav.style'

type NavOwnProps = {
  className?: string
  children?: React.ReactNode
  minimized?: boolean
}

export type NavProps = NavOwnProps & Omit<ComponentProps<'nav'>, keyof NavOwnProps>

function Nav(props: NavProps): ReactElement {
  const {
    children,
    className = '',
    minimized = false,
    ...rest
  } = props

  return (
    <nav
      className={cn('Nav', className, { minimized, 'not-minimized': !minimized })}
      css={style}
      {...rest}
      aria-label={'Main navigation'}
    >
      {children}
    </nav>
  )
}

export default Nav
